import { render, staticRenderFns } from "./QuestionReview.vue?vue&type=template&id=1d194c6a&"
import script from "./QuestionReview.vue?vue&type=script&lang=js&"
export * from "./QuestionReview.vue?vue&type=script&lang=js&"
import style0 from "./QuestionReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports